export namespace MainPageTypes {
    export type CardOptions = {
        translateY: number;
        rightOffset: number;
        subtractedWidth: number;
        cardElement: HTMLElement;
    }

    export type ConvertedCardOptions = {
        CARD_TRANSLATE_Y_TO_BOTTOM: number;
        CARD_OFFSET_X_RIGHT: number;
        CARD_SUBTRACT_WIDTH: number;
    }

    export enum ThirdScreenSwitchAngleViewTypeEnum {
        PRIMARY = "face",
        SECONDARY = "body"
    }
}
